import { render, staticRenderFns } from "./I18nBatchManagement.vue?vue&type=template&id=1b3540b8&scoped=true&"
import script from "./I18nBatchManagement.vue?vue&type=script&lang=js&"
export * from "./I18nBatchManagement.vue?vue&type=script&lang=js&"
import style0 from "./I18nBatchManagement.vue?vue&type=style&index=0&id=1b3540b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3540b8",
  null
  
)

export default component.exports